import { Component, OnInit } from '@angular/core';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Ng2IzitoastService } from 'ng2-izitoast';

@Component({
  selector: 'app-fondos-molduras',
  templateUrl: './fondos-molduras.component.html',
  styleUrls: ['./fondos-molduras.component.scss']
})
export class FondosMoldurasComponent implements OnInit {
  respuestaMolduras:any;
  molduras;

  constructor(private _get:CatalogosService, private _agregarMoldura: CatalogosService, private _editarMoldura:CatalogosService,
    private _updateMoldura: CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService) { }
  enviroment = environment.BASE_URL;
  dtOptions: DataTables.Settings = {
    dom: 'tip',                      // Estructura de la tabla     --> https://datatables.net/reference/option/dom
    lengthMenu: [],                      // Menú de tamaños de página   --> https://datatables.net/reference/option/lengthMenu
    order: [1, 'desc'],
    paging: true,
    pagingType: 'simple_numbers',
    pageLength: 10,
  };
  dtTrigger: Subject<any> = new Subject();
  p: number = 1;

  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;

  formulario;
  formularioEdit;

  datosItem;
  imagenActual;
  itemId;
  data;

  ngOnInit(): void {
    this.getFondosMolduras();
    this.formulario = {
      'nombre':'',
      imagen: '',
    }

    this.formularioEdit = {
      'nombre':'',
      imagen: '',
    }
  }

  getFondosMolduras(){
    this._get.getFondosMolduras().subscribe(
      data => {
        this.respuestaMolduras = data;
        if(this.respuestaMolduras.success){
          this.molduras = this.respuestaMolduras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }


  agregarFondoMoldura(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._agregarMoldura.agregarFondoMoldura(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getFondosMolduras();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  editarFondoMoldura(moldura){
    this.data = {
      'moldura':moldura,
    }
    this._editarMoldura.editarFondoMoldura(this.data).subscribe(
      data => {
        this.respuestaEditar= data;
        if(this.respuestaEditar.success){
          this.datosItem = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosItem.nombre;
          this.imagenActual = this.datosItem.imagen;
          this.itemId = moldura;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateFondoMoldura(moldura){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('fondo_moldura', moldura);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updateMoldura.updateFondoMoldura(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getFondosMolduras();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
